import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { PermRolComponent } from './perm-rol.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PermComponent } from './perm/perm.component';


export const routes: any = [
  { path: '', component: PermRolComponent, pathMatch: 'full' }
];


import { DragDropModule } from '@angular/cdk/drag-drop';


@NgModule({
  declarations: [
    PermRolComponent,
    PermComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    SharedModule,
    DragDropModule,
    ReactiveFormsModule,
    FormsModule,
  ]
})
export class PermRolModule { }
